export default __webpack_public_path__ + "static/media/336.30a48556.png";